var map = {
	"./1abdulify.png": 9480,
	"./abdul-on-couch.jpg": 2188,
	"./abdul-sitting.jpg": 7152,
	"./abdul-sitting2.jpg": 5640,
	"./abdul-standing.jpg": 8374,
	"./abdul-standing2.jpg": 8846,
	"./abdulify (3).png": 1221,
	"./abdulify (4).png": 572,
	"./abdulify-light.png": 6610,
	"./abdulify-mini-light.png": 2322,
	"./abdulify-mini.png": 4065,
	"./abdulify.png": 9489,
	"./abdullahi.jpeg": 1716,
	"./academy.jpg": 781,
	"./airbnbLogo.png": 1476,
	"./android.svg": 392,
	"./angular.svg": 5439,
	"./aws.png": 7556,
	"./aws.svg": 4150,
	"./azure.svg": 1084,
	"./bitbucket.svg": 9958,
	"./bootstrap.svg": 4127,
	"./cashelio.svg": 9189,
	"./codeInLogo.webp": 4796,
	"./contactMail.webp": 436,
	"./contactMailDark.svg": 9812,
	"./csharp.svg": 9842,
	"./css.svg": 9900,
	"./developerActivity.svg": 9504,
	"./dignig.png": 6997,
	"./do.svg": 696,
	"./docker.svg": 7539,
	"./dotnet.svg": 4269,
	"./eloksware.PNG": 4733,
	"./epayplus.png": 5762,
	"./facebookLogo.png": 6282,
	"./favicon_io (4)/android-chrome-192x192.png": 2309,
	"./favicon_io (4)/android-chrome-512x512.png": 309,
	"./favicon_io (4)/apple-touch-icon.png": 1466,
	"./favicon_io (4)/favicon-16x16.png": 6405,
	"./favicon_io (4)/favicon-32x32.png": 1573,
	"./favicon_io (4)/favicon.ico": 9441,
	"./favicon_io (4)/site.webmanifest": 4334,
	"./firebase.svg": 5920,
	"./git.svg": 7173,
	"./github.svg": 3322,
	"./gitlab.svg": 7042,
	"./google.svg": 6598,
	"./googleAssistant.svg": 9650,
	"./googleAssistantLogo.webp": 4217,
	"./harvardLogo.png": 7594,
	"./haskaar.jpg": 3478,
	"./html.svg": 4956,
	"./java.svg": 7515,
	"./jira.svg": 3759,
	"./jquery.svg": 8029,
	"./js.svg": 6410,
	"./jsFramework.svg": 4406,
	"./kube.svg": 4444,
	"./laravel.svg": 2826,
	"./manOnTable.svg": 3350,
	"./microsoft.jpg": 3239,
	"./microsoft.png": 4343,
	"./ministry.jpg": 9512,
	"./mobileweb.jpeg": 3272,
	"./mongoDb.svg": 6023,
	"./mysql.svg": 3987,
	"./net.svg": 5580,
	"./netcore.svg": 3481,
	"./nexquiz.png": 885,
	"./nextekk.PNG": 9892,
	"./nextuLogo.webp": 3480,
	"./nira.png": 6531,
	"./node.svg": 4843,
	"./npm.svg": 8994,
	"./php.svg": 5113,
	"./postman.svg": 9887,
	"./programmer.svg": 2075,
	"./pwa.webp": 7571,
	"./pwaLogo.webp": 4300,
	"./python.svg": 33,
	"./qore.png": 4428,
	"./quickraiz.jpg": 9364,
	"./quoraLogo.png": 2956,
	"./react.svg": 9624,
	"./saayaHealthLogo.webp": 3267,
	"./sass.svg": 4265,
	"./secureplus.png": 2280,
	"./skill.svg": 1262,
	"./slack.svg": 4809,
	"./sqlserver.svg": 9664,
	"./stanfordLogo.png": 6893,
	"./swagger.svg": 2705,
	"./talksCardBack.svg": 7175,
	"./talksCardBackAlt.svg": 6740,
	"./techbay.png": 9399,
	"./trello.svg": 401,
	"./udacity.png": 5566,
	"./umyu.jpg": 4739,
	"./uofa.jpeg": 6709,
	"./vs.svg": 5958,
	"./zedcrest.jpg": 21,
	"./zedcrest.png": 3845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;